import React from 'react';
import ProgressiveImage from './ProgressiveImage.jsx';

const getOptimizedImageUrl = (imageUrl) => imageUrl.replace(/\.(png|jpe?g)$/i, '.webp');
const getResponsiveImageSrcSet = (imageUrl) => {
  const baseImageUrl = imageUrl.replace(/\.(png|jpe?g)$/i, '');
  return `${baseImageUrl}-256.webp 256w, ${baseImageUrl}.webp 512w`;
};
const galleryImageSizes = '(max-width: 640px) 44vw, (max-width: 1024px) 30vw, 22vw';

const InstagramWall = ({ posts, linkToSeeMore }) => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 md:mb-10 relative inline-block">
        <span className="relative z-10">From Our Fluffy Community</span>
        <svg className="absolute -bottom-2 left-0 w-full h-3 text-pink-200" viewBox="0 0 100 20" preserveAspectRatio="none">
          <path d="M0,0 Q50,20 100,0" fill="currentColor" />
        </svg>
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-7">
        {posts.map((post, index) => (
          <div 
            key={index} 
            className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-102 hover:-rotate-1 flex flex-col"
            style={{ boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)' }}
          >
            <a href={post.link} className="flex-grow block relative group">
              <div className="absolute inset-0 bg-gradient-to-b from-transparent to-pink-900 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
              <div className="aspect-square">
                <ProgressiveImage
                  src={post.imageUrl}
                  optimizedSrc={getOptimizedImageUrl(post.imageUrl)}
                  optimizedSrcSet={getResponsiveImageSrcSet(post.imageUrl)}
                  alt={post.caption}
                  loading="lazy"
                  decoding="async"
                  fetchPriority="low"
                  sizes={galleryImageSizes}
                  width={512}
                  height={512}
                  containerClassName="bg-pink-50"
                  imgClassName="object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-3 md:p-4 relative">
                <div className="flex items-center mb-2">
                  <div className="w-8 h-8 rounded-full bg-gradient-to-r from-pink-400 to-purple-400 flex items-center justify-center text-white font-bold text-xs mr-2">
                    {post.username.charAt(0).toUpperCase()}
                  </div>
                  <p className="text-gray-800 text-sm font-semibold truncate">{post.username}</p>
                </div>
                <p className="text-gray-700 text-xs mt-1 md:mt-2 line-clamp-3 h-12 overflow-hidden">{post.caption}</p>
              </div>
            </a>
            <a 
              href={post.link} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-pink-500 hover:text-pink-700 text-xs p-3 md:p-4 mt-auto inline-block cursor-pointer font-medium flex items-center"
            >
              <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
              See on Instagram
            </a>
          </div>
        ))}
        <a 
          href={linkToSeeMore} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="bg-gradient-to-r from-pink-400 to-purple-400 rounded-2xl flex flex-col items-center justify-center text-white text-base font-semibold p-5 cursor-pointer shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
        >
          <span className="text-3xl mb-2">🐾</span>
          <span>See more on our page</span>
          <span className="text-xl mt-1">→</span>
        </a>
      </div>
    </div>
  );
};

export default InstagramWall;
